/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SiteIntervenantDto } from '../../models/site-intervenant-dto';

export interface GetSitesP1ByIdIntervenant$Params {
  idIntervenant: string;
}

export function getSitesP1ByIdIntervenant(
  http: HttpClient,
  rootUrl: string,
  params: GetSitesP1ByIdIntervenant$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<SiteIntervenantDto>> {
  const rb = new RequestBuilder(rootUrl, getSitesP1ByIdIntervenant.PATH, 'get');
  if (params) {
    rb.path('idIntervenant', params.idIntervenant, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SiteIntervenantDto>;
    })
  );
}

getSitesP1ByIdIntervenant.PATH = '/v1/site-intervenant/p1/by-intervenant/{idIntervenant}';
